import React from 'react';
import "./footer.css"

const Footer = () => {
  return (
    <footer className="footer">
        <div className="footer__container container">
            <h1 className="footer__title">Mustopha</h1>

            <ul className="footer__list">
                <li>
                    <a href="#about" className="footer__link">About</a>
                </li>
                <li>
                    <a href="#portfolio" className="footer__link">Projects</a>
                </li>
                <li>
                    <a href="#testimonials" className="footer__link">Testimonials</a>
                </li>
            </ul>

            <div className="footer__social">
                <a href='https://m.me/techVersifier' className='footer__social-link' target='_blank' rel='noopener noreferrer'> 
                    <i className="bx bxl-facebook"></i>
                </a>
                <a href='https://instagram.com/techversifier' className='footer__social-link' target='_blank' rel='noopener noreferrer'> 
                    <i className="bx bxl-instagram"></i>
                </a>
                <a href='https://x.com/TechVersifier' className='footer__social-link' target='_blank' rel='noopener noreferrer'> 
                    <i className="bx bxl-twitter"></i>
                </a>
            </div>

            <span className="footer__copy">
                &#169; MIONova. All rights reserved
            </span>
        </div>
    </footer>
  )
}

export default Footer

